import React from 'react'
import PropTypes from 'prop-types'
import styles from '../subscription-plan.css'
import { basicPlan } from '../../../../../modules/price-table/constants'
import { E2E_SELECTORS } from '../../../../../e2e-selectors'
import { priceChangeAlertMessage } from '../../../../../modules/shared/subscription-constants'

/**
 * temp price change alert msg displayed under my account  -> my plan.
 * only displayed when user's current plan matches the plan that's going to increase price
 */
const MyAccountPriceChangeAlert = ({ currentPlanSku, upcomingPlanSku }) => {
  if (currentPlanSku === basicPlan.sku || upcomingPlanSku === basicPlan.sku) {
    return (
      <div className={styles.priceChangeAlertContainer}>
        <span data-e2e={E2E_SELECTORS.PRICE_CHANGE_ALERT}>
          {priceChangeAlertMessage.myAccount}
        </span>
      </div>
    )
  }
  return null
}

MyAccountPriceChangeAlert.propTypes = {
  currentPlanSku: PropTypes.string,
  upcomingPlanSku: PropTypes.string
}

export default MyAccountPriceChangeAlert
